import { render } from "./HistorialProspectosPage.vue?vue&type=template&id=340e95ed"
import script from "./HistorialProspectosPage.vue?vue&type=script&lang=js"
export * from "./HistorialProspectosPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__